import Vue from 'vue'

interface Data {
  canvas: HTMLCanvasElement
}

interface Methods {
  getInputWidth: (
    text: string,
    el?: Element,
    defaultFontSize?: string,
    defaultPaddingLeft?: number,
    defaultPaddingRight?: number,
    defaultFontFamily?: string,
  ) => string
}

export default Vue.extend<Data, Methods, {}, {}>({
  data() {
    return {
      canvas: document.createElement('canvas'),
    }
  },
  methods: {
    getInputWidth(
      text = '',
      el?: Element,
      defaultFontSize = '1rem',
      defaultPaddingLeft = 0,
      defaultPaddingRight = 0,
      defaultFontFamily = 'Roboto, Helvetica, Arial, sans-serif',
    ): string {
      const context = this.canvas.getContext('2d')
      if (context) {
        const styles = el
          ? getComputedStyle(el, null)
          : {
              fontSize: defaultFontSize,
              fontFamily: defaultFontFamily,
              paddingLeft: `${defaultPaddingLeft}px`,
              paddingRight: `${defaultPaddingRight}px`,
            }
        context.font = `${styles.fontSize} ${styles.fontFamily}`
        const metrics = context.measureText(text)
        return `calc(${metrics.width}px + ${styles.paddingLeft} + ${styles.paddingRight} + ${styles.fontSize} / 2)`
      }
      return `${text.length}ch`
    },
  },
})
